var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIntroductionHhmtGreyFillIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 9.999,
    r: 8.333,
    fill: "#778CB8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 18.333a8.333 8.333 0 1 0 0-16.667 8.333 8.333 0 0 0 0 16.667ZM7.194 7.047a1.826 1.826 0 0 1 1.719-1.214h1.897a2.054 2.054 0 0 1 1.022 3.838l-1.05.602a.783.783 0 0 1-.782.768.78.78 0 0 1-.781-.781v-.44c0-.28.15-.537.393-.677l1.443-.827a.492.492 0 0 0-.245-.918H8.913a.256.256 0 0 0-.245.173l-.013.039a.781.781 0 0 1-1.47-.52l.012-.04-.003-.003Zm1.764 6.077a1.042 1.042 0 1 1 2.083 0 1.042 1.042 0 0 1-2.083 0Z",
    fill: "#D4DCE5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntroductionHhmtGreyFillIcon);
export default __webpack_public_path__ + "static/media/introduction-hhmt-grey-fill-icon.e421a64bf7c98415dec83ac49ac76bb7.svg";
export { ForwardRef as ReactComponent };